import { TAbUseExperimentsState } from '../types/abUseExperiments';

export function isAbUseExperimentGroup(
  experiments: TAbUseExperimentsState,
  experimentName: string,
  targetGroup: string,
) {
  const experiment = experiments.find(e => e.experimentName === experimentName);

  if (experiment) {
    return experiment.groupName === targetGroup;
  }

  return false;
}
